<template>
  <div>
    <div class="subtitle">Nagrade</div>
    <div class="prizes-wrapper">
      <Slider :key="sliderRenderCount" autoSlidingDisabled="true" v-if="!isMobile">
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/smartphone.jpg" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">Xiaomi Redmi Note 9</span>
          </div>
        </div>
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/monitor.jpg" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">Philips Monitor 23.8"</span>
          </div>
        </div>
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/loudspeaker.png" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">JBL Flip 5</span>
          </div>
        </div>
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/headphones.jpg" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">Sennheiser HD 350BT</span>
          </div>
        </div>
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/earbuds.jpg" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">Anker SoundCore Life Note</span>
          </div>
        </div>
      </Slider>
      <div class="scrollable-slider" v-else>
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/smartphone.jpg" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">Xiaomi Redmi Note 9</span>
          </div>
        </div>
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/monitor.jpg" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">Philips Monitor 23.8"</span>
          </div>
        </div>
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/loudspeaker.png" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">JBL Flip 5</span>
          </div>
        </div>
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/headphones.jpg" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">Sennheiser HD 350BT</span>
          </div>
        </div>
        <div class="prize slider-item">
          <div class="prize-image-wrapper">
            <img class="prize-image" src="@/assets/app-icons/prizes/earbuds.jpg" draggable="false" />
          </div>
          <div class="prize-caption">
            <span class="prize-label">Anker SoundCore Life Note</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deviceHandling } from '@/mixins.js';

import Slider from '@/components/app/Slider.vue';

export default {
  name: 'Rewards',
  mixins: [deviceHandling],
  components: { Slider },
  data() {
    return {
      sliderRenderCount: 0,
    };
  },
  methods: {},
  created() {
    window.addEventListener('resize', () => this.sliderRenderCount++);
  },
};
</script>

<style scoped>
.more-info-title {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
}

.subtitle {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 36px;
  color: #ffffff;
}

.prizes-wrapper {
  margin: 0 -115px;
  margin-top: 60px;
}
.prizes-wrapper .slider {
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  white-space: nowrap;
  padding: 25px;
}
.prizes-wrapper .prize {
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.prize-image-wrapper {
  width: 180px;
  height: 180px;
  background-color: white;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
}
.prizes-wrapper .prize:first-child {
  margin-left: 90px;
}
.prizes-wrapper .prize:not(:last-child) {
  margin-right: 40px;
}
.prizes-wrapper .prize .prize-image {
  max-width: 90%;
  max-height: 90%;
}
.prizes-wrapper .prize .prize-caption {
  width: 205px;
  max-width: 180px;
  margin-top: 32px;
}
.prizes-wrapper .prize .prize-label {
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
  white-space: normal;
}

.scrollable-slider {
  display: flex;
  overflow: auto;
  margin-right: -24px;
}

@media screen and (max-width: 768px) {
  .prizes-wrapper {
    margin-left: 0;
    margin-right: 0;
  }
  .prizes-wrapper .prize:first-child {
    margin-left: 0;
  }
  .prizes-wrapper .prize:last-child {
    padding-right: 24px;
  }
}

@media screen and (max-width: 550px) {
  .subtitle {
    font-size: 24px;
    line-height: 29px;
  }
}
</style>
